{
  "common": {
    "appName": "TrasaFlow",
    "cancel": "Odustani",
    "confirm": "Potvrdi",
    "close": "Zatvori",
    "retry": "Pokušaj ponovno",
    "loading": "Učitavanje …",
    "back": "Natrag",
    "yes": "Da",
    "no": "Ne",
    "all": "Sve",
    "reset": "Poništi",
    "notAvailableYet": "Još nije dostupno",
    "required": "Obavezno polje",
    "none": "–"
  },
  "a11y": {
    "skipToContent": "Preskoči na sadržaj",
    "mainNav": "Glavna navigacija",
    "openMenu": "Otvori izbornik",
    "menuTitle": "Navigacija"
  },
  "header": {
    "organization": "Organizacija",
    "user": "Prijavljeni korisnik",
    "language": "Jezik",
    "logout": "Odjava",
    "passkey": "Postavi passkey",
    "userMenu": "Izbornik korisnika"
  },
  "language": {
    "hr": "Hrvatski",
    "de": "Deutsch",
    "en": "English"
  },
  "orgKind": {
    "GC": "Generalni izvođač",
    "CLIENT": "Naručitelj",
    "SUB": "Podizvođač"
  },
  "nav": {
    "tasks": "Moji zadaci",
    "inbox": "Poštanski sandučić",
    "orders": "Nalozi",
    "map": "Karta",
    "calendar": "Kalendar",
    "review": "Kontrola",
    "pits": "Jame",
    "deadlines": "Rokovi",
    "crews": "Kolone",
    "users": "Korisnici",
    "dashboard": "Nadzorna ploča",
    "formsPreview": "Pregled obrazaca",
    "imports": "OTW uvoz",
    "forms": "Obrasci",
    "areas": "Područja",
    "dispatch": "Tjedni plan",
    "permits": "Dozvole"
  },
  "pages": {
    "tasks": {
      "title": "Moji zadaci",
      "description": "Sve što danas od vas traži odluku ili radnju.",
      "emptyTitle": "Nema otvorenih zadataka",
      "emptyBody": "Dodijeljeni nalozi, kontrole na čekanju i kritični rokovi pojavit će se ovdje."
    },
    "map": {
      "title": "Karta",
      "description": "Nalozi, jame i kolone na karti.",
      "emptyTitle": "Karta se priprema",
      "emptyBody": "Lokacije naloga i jama pojavit će se ovdje čim se prikaz karte poveže."
    },
    "calendar": {
      "title": "Kalendar",
      "description": "Raspored kolona i termina.",
      "emptyTitle": "Nema termina",
      "emptyBody": "Ovdje se pojavljuju zakazani nalozi i angažmani kolona. Blokade poput otvorenih jama ili nedostajućih dozvola odmah su označene."
    },
    "review": {
      "title": "Kontrola",
      "description": "Fotografije, sati i prijave „izvan lokacije” na odobrenje.",
      "emptyTitle": "Nema ničega za kontrolu",
      "emptyBody": "Završeni radni koraci i upadljivi dokazi dolaze ovdje u red za kontrolu."
    },
    "pits": {
      "title": "Jame",
      "description": "Otvorene, privremeno zatvorene i završene građevinske jame.",
      "emptyTitle": "Nema evidentiranih jama",
      "emptyBody": "Jame iz obrazaca za zemljane radove pojavit će se ovdje sa stanjem, kartom i filtrima."
    },
    "deadlines": {
      "title": "Rokovi",
      "description": "Nadolazeći i istekli rokovi s razinama upozorenja.",
      "emptyTitle": "Nema rokova",
      "emptyBody": "Rokovi za naloge i dozvole prikazuju se ovdje s odgovornom osobom i stanjem potvrde."
    },
    "crews": {
      "title": "Kolone",
      "description": "Upravljanje kolonama vaše tvrtke.",
      "emptyTitle": "Još nema kolona",
      "emptyBody": "Stvorite kolone kako bi se nalozi i radni koraci mogli dodijeliti."
    },
    "users": {
      "title": "Korisnici",
      "description": "Korisnici i uloge vaše organizacije.",
      "emptyTitle": "Nema drugih korisnika",
      "emptyBody": "Pozvani korisnici i njihove uloge pojavit će se ovdje."
    },
    "dashboard": {
      "title": "Nadzorna ploča",
      "description": "Pregled naloga, rokova i napretka (pristup samo za čitanje).",
      "emptyTitle": "Još nema pokazatelja",
      "emptyBody": "Čim postoje nalozi, ovdje ćete na prvi pogled vidjeti stanje, rokove i završenost."
    },
    "permits": {
      "title": "Dozvole",
      "description": "Poštanski pretinac zahtjeva: poruke tijela koje nisu pridružene zahtjevu. Same zahtjeve uređujete na nalogu."
    }
  },
  "login": {
    "title": "Prijava u TrasaFlow",
    "intro": "Prijava ide preko središnje usluge prijave vaše organizacije.",
    "button": "Prijava",
    "loggedOut": "Odjavljeni ste.",
    "expired": "Vaša je sesija istekla. Prijavite se ponovno.",
    "error": "Prijava nije uspjela."
  },
  "authCallback": {
    "working": "Dovršavanje prijave …",
    "errorTitle": "Prijava nije uspjela",
    "errorBody": "Usluga prijave nije potvrdila prijavu. Pokušajte ponovno."
  },
  "meError": {
    "title": "Vaš račun nije bilo moguće učitati",
    "body": "Podaci o korisniku trenutačno nisu dostupni. Pokušajte ponovno ili se odjavite.",
    "forbidden": "Za vaš račun u TrasaFlowu nije postavljen pristup. Obratite se svojoj administraciji."
  },
  "notFound": {
    "title": "Stranica nije pronađena",
    "body": "Ta adresa ne postoji.",
    "home": "Na početnu stranicu"
  },
  "forbidden": {
    "title": "Nema pristupa",
    "body": "Nemate potrebno pravo za ovu stranicu."
  },
  "errors": {
    "generic": "Nešto je pošlo po zlu.",
    "http": "Poslužitelj je javio pogrešku ({{status}}).",
    "network": "Nema veze s poslužiteljem.",
    "notConnectedTitle": "Još nije povezano",
    "notConnectedBody": "Pozadinski sustav još ne isporučuje te podatke. Pojavit će se ovdje čim krajnja točka bude dostupna."
  },
  "filters": {
    "title": "Filtri",
    "max": "Najviše {{count}} filtara po popisu"
  },
  "orders": {
    "title": "Nalozi",
    "description": "Nalozi vaše organizacije.",
    "filterStatus": "Status",
    "filterSearch": "Pretraga",
    "searchPlaceholder": "Broj, adresa ili referenca",
    "colNumber": "Nalog",
    "colStatus": "Status",
    "colAddress": "Adresa",
    "colDeadline": "Sljedeći rok",
    "emptyTitle": "Nema naloga",
    "emptyBody": "Za ove filtre nema naloga.",
    "unavailableTitle": "Popis naloga još nije povezan",
    "unavailableBody": "Poslužitelj još ne isporučuje popis naloga. Pojavit će se ovdje čim bude dostupan.",
    "listLabel": "Popis naloga",
    "filterOrderType": "Vrsta naloga",
    "filterArea": "Područje",
    "filterSub": "Podizvođač",
    "filterAmpel": "Semafor roka",
    "groupBy": "Grupiraj područja po",
    "areasTitle": "Područja",
    "areaName": "Područje",
    "areaOpen": "Otvoreno",
    "areaTotal": "Ukupno",
    "areaNext": "Sljedeći rok",
    "areaPits": "Otvorene jame",
    "areaFilter": "Prikaži naloge",
    "areaNone": "(bez područja)",
    "colType": "Vrsta",
    "colArea": "Područje",
    "colAssigned": "Podizvođač",
    "selectAll": "Odaberi sve učitane naloge",
    "selectRow": "Odaberi nalog {{number}}",
    "selectedCount": "Odabrano: {{count}}",
    "loadMore": "Učitaj još",
    "loadedCount": "Učitano naloga: {{count}}",
    "allLoaded": "Svi nalozi učitani",
    "subShort": "Podizvođač {{id}}",
    "noSub": "bez podizvođača",
    "groupByValue": {
      "rajon": "Rajon",
      "municipality": "Općina",
      "postal_code": "Poštanski broj",
      "mdf": "MDF"
    }
  },
  "order": {
    "back": "Natrag na popis naloga",
    "unavailableTitle": "Nalog nije dostupan",
    "unavailableBody": "Ovaj nalog ne postoji, nije vam vidljiv ili detaljni prikaz još nije povezan.",
    "number": "Broj naloga",
    "externalRef": "Referenca naručitelja",
    "status": "Status",
    "clientStatus": "Status kod naručitelja",
    "address": "Adresa",
    "region": "Regija",
    "nextDeadline": "Sljedeći rok",
    "version": "Verzija",
    "actions": "Radnje na nalogu",
    "noActions": "U ovom stanju za vas nema dostupnih radnji.",
    "blockers": "Ovo sprječava radnju",
    "done": "Radnja „{{action}}” izvršena.",
    "type": "Vrsta naloga",
    "area": "Područje",
    "nearbyTitle": "U blizini",
    "nearbyRadius": "Radijus",
    "nearbyEmpty": "Nema otvorenih naloga u blizini.",
    "nearbyError": "Nalozi u blizini nisu se mogli učitati.",
    "distance": "{{m}} m",
    "stepsTitle": "Radni koraci",
    "stepsEmpty": "Još nema radnih koraka.",
    "deadlinesTitle": "Rokovi",
    "deadlinesEmpty": "Nema rokova.",
    "crewTitle": "Kolona",
    "actionDue": "Rok za postupanje",
    "notFoundTitle": "Nalog nije pronađen",
    "notFoundBody": "Ovaj nalog ne postoji ili vam nije vidljiv.",
    "stepStatus": {
      "OPEN": "Otvoreno",
      "IN_PROGRESS": "U tijeku",
      "DONE": "Završeno",
      "NEEDS_FOLLOWUP": "Potreban nastavak radova",
      "BLOCKED": "Blokirano",
      "NOT_APPLICABLE": "Nije primjenjivo"
    },
    "deadlineState": {
      "OPEN": "Otvoreno",
      "EXTENDED": "Produljeno",
      "OVERDUE": "Rok za postupanje prekoračen",
      "EXPIRED": "Isteklo",
      "DONE": "Završeno",
      "CANCELLED": "Otkazano"
    },
    "reschedule": "Preplaniraj",
    "subCrew": "Ekipa podizvođača (neobavezno)",
    "assignSub": "Podizvođač",
    "tabs": "Prikazi naloga",
    "tab": {
      "details": "Detalji",
      "history": "Povijest"
    }
  },
  "orderStatus": {
    "NEW": "Novo",
    "CLASSIFIED": "Klasificirano",
    "ASSIGNED": "Dodijeljeno",
    "ACCEPTED": "Prihvaćeno",
    "SCHEDULED": "Zakazano",
    "IN_PROGRESS": "U izvođenju",
    "BLOCKED": "Blokirano",
    "COMPLETION_REPORTED": "Završetak prijavljen",
    "GC_APPROVED": "Odobrio GI",
    "REPORTED_TO_CLIENT": "Prijavljeno naručitelju",
    "CLIENT_ACCEPTED": "Preuzeto",
    "BILLED": "Naplaćeno",
    "CANCELLED": "Stornirano"
  },
  "orderAction": {
    "CLASSIFY": "Klasificiraj",
    "ASSIGN": "Dodijeli",
    "HAND_OVER": "Predaj",
    "ACCEPT": "Prihvati",
    "REJECT": "Odbij",
    "SCHEDULE": "Zakaži",
    "START": "Započni",
    "BLOCK": "Blokiraj",
    "UNBLOCK": "Ukloni blokadu",
    "REPORT_COMPLETION": "Prijavi završetak",
    "APPROVE": "Odobri",
    "RETURN_FOR_REWORK": "Vrati na doradu",
    "REPORT_TO_CLIENT": "Prijavi naručitelju",
    "RECORD_CLIENT_ACCEPTANCE": "Evidentiraj preuzimanje",
    "MARK_BILLED": "Označi kao naplaćeno",
    "CANCEL": "Storniraj"
  },
  "confirm": {
    "title": "Potvrditi „{{action}}”?",
    "description": "Radnja se izvršava odmah.",
    "irreversibleTitle": "„{{action}}” se ne može poništiti",
    "irreversibleDescription": "Ovu radnju nije moguće poništiti. Navedite razlog; on se bilježi u evidenciji.",
    "reasonLabel": "Razlog",
    "reasonHint": "Najmanje {{count}} znakova",
    "reasonTooShort": "Razlog je prekratak.",
    "pending": "Izvršava se …",
    "failed": "Radnja nije izvršena."
  },
  "inbox": {
    "title": "Poštanski sandučić",
    "description": "Upozorenja o rokovima, eskalacije, dodjele i sukobi sinkronizacije.",
    "emptyTitle": "Sve je riješeno",
    "emptyBody": "Nema poruka za vas.",
    "unavailableTitle": "Poštanski sandučić još nije povezan",
    "unavailableBody": "Poslužitelj još ne isporučuje poštanski sandučić. Obvezne obavijesti pojavit će se kasnije ovdje i na vrhu svake stranice.",
    "stateLabel": "Prikaz",
    "state": {
      "open": "Otvoreno",
      "acknowledged": "Potvrđeno",
      "all": "Sve"
    },
    "kind": {
      "DEADLINE_WARNING": "Upozorenje o roku",
      "DEADLINE_EXPIRED": "Rok istekao",
      "ESCALATION": "Eskalacija",
      "SYNC_CONFLICT": "Sukob sinkronizacije",
      "ASSIGNMENT": "Dodjela",
      "PERMIT": "Dozvola",
      "SYSTEM": "Sustav"
    },
    "severity": {
      "INFO": "Informacija",
      "WARNING": "Upozorenje",
      "CRITICAL": "Kritično"
    },
    "acknowledge": "Potvrdi primitak",
    "acknowledging": "Potvrđivanje …",
    "ackFailed": "Potvrda nije uspjela. Pokušajte ponovno.",
    "goToAction": "Na radnju",
    "mandatoryTitle": "Obvezna obavijest: potrebna potvrda",
    "mandatoryRegion": "Obvezne obavijesti",
    "ackDue": "Potvrditi do {{date}}",
    "acknowledgedAt": "Potvrđeno {{date}}",
    "listLabel": "Poruke",
    "mandatoryCount": "Obvezne obavijesti koje čekaju potvrdu: {{count}}"
  },
  "forms": {
    "previewTitle": "Pregled obrazaca",
    "previewDescription": "Prikazuje definicije obrazaca onako kako ih vrednuje terenska aplikacija. Ništa se ne sprema.",
    "selectForm": "Obrazac",
    "version": "Verzija {{version}}",
    "formArea": "Obrazac",
    "resultArea": "Vrednovanje",
    "outcome": "Ishod",
    "noOutcome": "Još nema ishoda (nedostaju obavezna polja ili su vrijednosti neispravne)",
    "stepStatus": "Status koraka",
    "pitState": "Stanje jame",
    "pitDetails": "Nedostajući sloj",
    "followUps": "Slijedeći koraci",
    "missingFields": "Nedostajuća obavezna polja",
    "invalidFields": "Neispravne vrijednosti",
    "visibleCount": "Vidljiva polja: {{count}}",
    "none": "nema",
    "clearAnswers": "Očisti odgovore",
    "validate": "Provjeri unos",
    "choose": "Odaberite",
    "errorMissing": "Obavezno polje",
    "errorInvalid": "Neispravna vrijednost",
    "photoAdd": "Odaberi datoteke",
    "photoNote": "Pregled: fotografije se ovdje ne učitavaju, samo se broje. Najmanje {{min}}.",
    "photoNoteMax": "Najmanje {{min}}, najviše {{max}}.",
    "photoCount": "Odabrano datoteka: {{count}}",
    "photoRemove": "Ukloni",
    "signerName": "Ime osobe koja potpisuje",
    "signatureToggle": "Označi potpis kao prisutan",
    "pitLabel": "Oznaka spojnice ili naziv jame",
    "unsupported": "Ova vrsta polja ne prikazuje se u web pregledu.",
    "geometryNote": "Geometrija se bilježi u terenskoj aplikaciji.",
    "noPermission": "Nedostaje pravo za pregled obrazaca.",
    "stepStatusValue": {
      "DONE": "Završeno",
      "NEEDS_FOLLOWUP": "Potreban nastavak radova",
      "IN_PROGRESS": "U tijeku",
      "BLOCKED": "Blokirano"
    },
    "pitStateValue": {
      "offen": "Otvorena",
      "provisorisch": "Privremeno zatvorena",
      "fertig": "Završena"
    },
    "pitDetailValue": {
      "asphalt_fehlt": "Nedostaje asfalt",
      "pflaster_fehlt": "Nedostaju opločnici"
    }
  },
  "bundle": {
    "action": "Dodijeli kao dnevni paket",
    "title": "Dodjela dnevnog paketa",
    "description": "Nalozi ({{count}}) bit će dodijeljeni i objedinjeni za odabrani dan. Ako se jedan nalog ne može objediniti, ništa se ne mijenja.",
    "day": "Dan",
    "done": "Dnevni paket za {{day}} stvoren s nalozima: {{count}}.",
    "target": "Kolona ili podizvođač",
    "ASSIGNEE_WITHOUT_PRICE_LIST": "nema cjenika",
    "crewOption": "Vlastita kolona",
    "subOption": "Podizvođač",
    "targetsUnavailable": "Popis ekipa i podizvođača nije dostupan. Pokušajte ponovno kasnije."
  },
  "ampel": {
    "red": "Prekoračeno",
    "amber": "Dospijeva u 3 dana",
    "green": "U planu",
    "none": "Bez roka",
    "done": "Završeno"
  },
  "map": {
    "listTitle": "Nalozi na karti ({{count}})",
    "truncated": "Prikazuje se samo prvih {{count}} naloga. Suzite filtre.",
    "canvasLabel": "Karta naloga. Isti nalozi navedeni su ispod kao popis.",
    "legend": "Semafor roka",
    "noLocation": "Nalozi bez lokacije ({{count}}) nisu na karti, ali jesu u popisu.",
    "error": "Karta se nije mogla učitati.",
    "loadError": "Nalozi se nisu mogli učitati.",
    "zoomIn": "Povećaj",
    "zoomOut": "Smanji",
    "resetNorth": "Poravnaj sjever"
  },
  "imports": {
    "title": "OTW uvoz",
    "description": "Učitajte ili zalijepite OTW popis, provjerite pregled i preuzmite ga jednim klikom.",
    "clientId": "Naručitelj",
    "clientIdHint": "Naručitelj čija se OTW lista uvozi.",
    "file": "Datoteka (XLSX, CSV ili TSV)",
    "paste": "Ili zalijepite TSV",
    "pasteHint": "Zaglavlje i retci iz OTW-a, odvojeni tabulatorima.",
    "preview": "Izradi pregled",
    "previewing": "Izrada pregleda …",
    "noInput": "Odaberite datoteku ili zalijepite TSV.",
    "summaryTitle": "Rezultat pregleda",
    "source": "Izvor",
    "rowsTitle": "Retci",
    "outcomeFilter": "Prikaži ishod",
    "colRow": "Redak",
    "colRef": "Referenca",
    "colOutcome": "Ishod",
    "colChanges": "Promjene",
    "emptyRows": "Nema redaka za ovaj filtar.",
    "outcome": {
      "NEW": "Novo",
      "CHANGED": "Promijenjeno",
      "UNCHANGED": "Nepromijenjeno",
      "INVALID": "Neispravno",
      "MISSING": "Nedostaje na popisu"
    },
    "diff": "{{field}}: {{from}} → {{to}}",
    "commit": "Preuzmi",
    "commitDescription": "Novih naloga: {{new}}, promijenjenih: {{changed}}. Naloga koji nedostaju na popisu (kandidati za storno): {{missing}}.",
    "committed": "Uvoz preuzet: novih {{new}}, promijenjenih {{changed}}.",
    "viewOrders": "Na naloge",
    "statusCommitted": "Preuzeto",
    "statusPreviewed": "Pregled"
  },
  "deadlines": {
    "filterType": "Vrsta",
    "filterResponsible": "Odgovorna osoba",
    "filterArea": "Područje",
    "filterAmpel": "Semafor",
    "filterState": "Stanje",
    "colAmpel": "Semafor",
    "colType": "Vrsta",
    "colOrder": "Nalog",
    "colArea": "Područje",
    "colActionDue": "Rok za postupanje",
    "colDue": "Istek",
    "colResponsible": "Odgovorna osoba",
    "colState": "Stanje",
    "colAck": "Potvrda",
    "colEscalation": "Eskalacija",
    "listLabel": "Popis rokova",
    "emptyTitle": "Nema rokova",
    "emptyBody": "Za ove filtre nema rokova.",
    "me": "Ja",
    "userShort": "Korisnik {{id}}",
    "ackNone": "Nema obavijesti",
    "ackOpen": "Otvoreno, do {{date}}",
    "ackDone": "Potvrđeno {{date}}",
    "escalationNone": "nema",
    "escalationLevel": "Razina {{count}}",
    "loadError": "Rokovi se nisu mogli učitati.",
    "kind": {
      "ACCEPTANCE": "Prihvat",
      "ORDER_ACCEPTANCE": "Prihvat",
      "VAO": "VAO",
      "PERMIT_VALIDITY": "Dozvola vrijedi do",
      "CLIENT_SLA": "Rok naručitelja",
      "CLIENT_DEADLINE": "Rok naručitelja",
      "CLIENT_SERVICE_TIME": "Servisno vrijeme naručitelja"
    }
  },
  "calendar": {
    "viewDay": "Dan",
    "viewWeek": "Tjedan",
    "viewMonth": "Mjesec",
    "viewList": "Popis",
    "today": "Danas",
    "calendarLabel": "Kalendar rokova",
    "actionDue": "Rok za postupanje",
    "due": "Istek",
    "permitExpiry": "Dozvola istječe",
    "icalTitle": "Pretplata na kalendar (iCal)",
    "icalNote": "Poveznica za pretplatu pojavit će se ovdje čim je pozadinski sustav osigura.",
    "legend": "Legenda",
    "loadError": "Kalendar se nije mogao učitati.",
    "prev": "Natrag",
    "next": "Naprijed",
    "appointment": "Termin",
    "icalCreate": "Izradi poveznicu za pretplatu",
    "icalRotate": "Izradi novu poveznicu",
    "icalExists": "Poveznica za pretplatu postoji. Zbog sigurnosti prikazuje se samo pri izradi. Nova poveznica poništava staru.",
    "icalLink": "Poveznica za pretplatu (prikazuje se jednom, kopirajte u kalendar)",
    "icalError": "Poveznica za pretplatu nije izrađena."
  },
  "dashboard": {
    "kpiTotal": "Ukupno naloga",
    "kpiOpen": "Otvoreno",
    "kpiDone": "Završeno",
    "kpiOverdue": "Prekoračeni rokovi",
    "kpiRate": "Završeno u %",
    "statusChartTitle": "Nalozi po fazi",
    "typeChartTitle": "Nalozi po vrsti",
    "funnelTitle": "Protočnost: dokle su nalozi stigli?",
    "upcomingTitle": "Sljedeći rokovi",
    "docTitle": "Napredak dokumentacije po nalogu",
    "docProgress": "{{done}} od {{total}} koraka završeno",
    "docNone": "Nema naloga u tijeku s radnim koracima.",
    "dataTable": "Podaci kao tablica",
    "colLabel": "Naziv",
    "colCount": "Broj",
    "colReached": "Dosegnuto (najmanje)",
    "noData": "Još nema naloga.",
    "readOnlyNote": "Pristup samo za čitanje. Cijene se ovdje ne prikazuju.",
    "chartSummary": "{{title}}: {{items}}",
    "loadError": "Pokazatelji se nisu mogli učitati.",
    "upcomingNone": "Nema nadolazećih rokova.",
    "orders": "Nalozi",
    "stage": {
      "intake": "Zaprimanje",
      "dispatch": "Dispozicija",
      "work": "Izvođenje",
      "review": "Kontrola",
      "client": "Naručitelj",
      "billing": "Naplata",
      "cancelled": "Stornirano"
    },
    "noType": "bez vrste",
    "acceptanceTitle": "Prijavljeno na preuzimanje",
    "acceptanceNone": "Nijedan nalog ne čeka vaše preuzimanje.",
    "acceptanceSince": "Prijavljeno {{date}}",
    "acceptanceHint": "Nalozi koje vam je generalni izvođač prijavio kao završene. Preuzimanje javljate generalnom izvođaču.",
    "acceptanceList": "Popis naloga za preuzimanje"
  },
  "files": {
    "title": "Datoteke",
    "empty": "Još nema provjerenih datoteka.",
    "enlarge": "Povećaj",
    "lightboxTitle": "Datoteka {{name}}",
    "close": "Zatvori",
    "prev": "Prethodna datoteka",
    "next": "Sljedeća datoteka",
    "download": "Otvori izvornik",
    "time": "Vrijeme snimanja",
    "gps": "GPS",
    "device": "Uređaj",
    "hash": "Kontrolni zbroj (SHA-256)",
    "status": "Status",
    "category": "Kategorija",
    "size": "Veličina",
    "noGps": "bez GPS signala",
    "none": "nije navedeno",
    "document": "Dokument",
    "noPreview": "Nema pregleda",
    "rejectedTitle": "Datoteka odbijena",
    "rejectedBody": "Ova datoteka nije prihvaćena. Razlog: {{reason}}",
    "loadError": "Datoteke se nisu mogle učitati.",
    "downloadError": "Izvornik se nije mogao učitati.",
    "counter": "Datoteka {{index}} od {{total}}",
    "photo": "Fotografija",
    "statusValue": {
      "PENDING_UPLOAD": "Učitavanje u tijeku",
      "VERIFYING": "Provjera u tijeku",
      "VERIFIED": "Provjereno",
      "REJECTED": "Odbijeno"
    },
    "rejectReason": {
      "HASH_MISMATCH": "Kontrolni zbroj se ne podudara",
      "SIZE_MISMATCH": "Veličina se ne podudara",
      "MALWARE": "Otkriven zlonamjerni softver",
      "UNSUPPORTED_TYPE": "Vrsta datoteke nije podržana"
    },
    "createdBy": "Snimio/la",
    "appVersion": "Verzija aplikacije"
  },
  "formsAdmin": {
    "title": "Obrasci",
    "description": "Učitavanje, uređivanje, vrednovanje na poslužitelju i objava definicija obrazaca.",
    "loadTitle": "Učitaj verziju",
    "keyLabel": "Ključ",
    "versionLabel": "Verzija",
    "load": "Učitaj",
    "known": "Poznati obrasci",
    "statusValue": {
      "DRAFT": "Skica",
      "PUBLISHED": "Objavljeno",
      "RETIRED": "Povučeno"
    },
    "editorLabel": "Definicija obrasca (JSON)",
    "readOnlyNote": "Objavljene verzije su nepromjenjive. Za izmjene stvorite novu verziju.",
    "newVersion": "Uredi kao novu verziju",
    "newForm": "Novi obrazac iz predloška",
    "jsonError": "Nije valjani JSON: {{message}}",
    "schemaOk": "Shema je valjana",
    "schemaErrors": "Povrede sheme ({{count}})",
    "saveDraft": "Spremi skicu",
    "saved": "Skica {{key}} v{{version}} spremljena.",
    "evaluate": "Vrednuj na poslužitelju",
    "evaluating": "Vrednovanje …",
    "serverResult": "Vrednovanje na poslužitelju",
    "drift": "Preglednik i poslužitelj se razlikuju: {{fields}}",
    "noDrift": "Preglednik i poslužitelj se podudaraju.",
    "publish": "Objavi",
    "publishDescription": "Objavljene verzije su nepromjenjive, a radni koraci ih fiksiraju. Svaka kasnija izmjena traži novu verziju.",
    "published": "Verzija {{version}} obrasca {{key}} objavljena.",
    "preview": "Pregled",
    "previewHint": "Pregled se pojavljuje čim je definicija valjana.",
    "violations": "Poslužitelj odbija definiciju",
    "unsavedChanges": "Nespremljene izmjene: prvo spremite, zatim objavite.",
    "referencePreview": "Pogledaj referentne obrasce",
    "loadFailed": "Ta verzija ne postoji ili vam nije vidljiva.",
    "saveFailed": "Skica nije spremljena.",
    "current": "Učitano: {{key}} v{{version}}",
    "notLoaded": "Definicija još nije učitana.",
    "versionMismatch": "Verzija u JSON-u ({{json}}) razlikuje se od učitane verzije ({{loaded}}).",
    "serverNoDefinition": "Prije vrednovanja učitajte ili unesite valjanu definiciju.",
    "actions": "Radnje na obrascu",
    "colForm": "Obrazac",
    "colStatus": "Status",
    "colPublished": "Objavljeno"
  },
  "passkey": {
    "title": "Brža prijava otiskom prsta ili Face ID-jem",
    "body": "S pristupnim ključem (passkey) otisak prsta ili lice zamjenjuju lozinku. Postavljanje traje minutu, a uvijek je dostupno u izborniku korisnika.",
    "setup": "Postavi sada",
    "later": "Kasnije"
  },
  "review": {
    "openCount": "Otvorenih točaka za kontrolu: {{count}}",
    "filterKind": "Vrsta",
    "filterFlag": "Razlog",
    "filterArea": "Područje",
    "listLabel": "Točke za kontrolu",
    "emptyTitle": "Nema ničega za kontrolu",
    "emptyBody": "Za ove filtre nema otvorenih točaka za kontrolu.",
    "loadError": "Red za kontrolu nije se mogao učitati.",
    "kind": {
      "VISIT": "Posjet",
      "PHOTO": "Fotografija",
      "MEASUREMENT": "Obračun"
    },
    "flag": {
      "backdated": "Unatrag datirano",
      "photo_time_implausible": "Vrijeme fotografije nevjerojatno",
      "open_too_long": "Predugo otvoreno",
      "off_site": "Izvan gradilišta",
      "no_fix": "Bez GPS signala",
      "clock_skew": "Sat odstupa",
      "capped": "Sati ograničeni",
      "joined_later": "Naknadno pridružen",
      "departure_missing": "Nedostaje odlazak",
      "rejected": "Odbijeno",
      "hash_mismatch": "Kontrolni zbroj se ne podudara",
      "malware": "Zlonamjerni softver",
      "measurement_submitted": "Čeka odobrenje"
    },
    "org": "Unio",
    "created": "Zaprimljeno",
    "arrived": "Dolazak",
    "departed": "Odlazak",
    "location": "Lokacija",
    "clockCorrected": "Vrijeme ispravio poslužitelj",
    "locationStatus": {
      "ON_SITE": "Na gradilištu",
      "OFF_SITE": "Izvan lokacije",
      "NO_FIX": "Bez GPS signala"
    },
    "attendance": "Prisutnost",
    "colPerson": "Osoba",
    "colStart": "Početak",
    "colEnd": "Kraj",
    "colHours": "Sati",
    "colFlags": "Napomene",
    "openEnd": "otvoreno",
    "photoCategory": "Kategorija slike",
    "capturedAt": "Snimljeno",
    "gpsFix": "GPS signal",
    "gpsYes": "da",
    "gpsNo": "ne",
    "rejectReason": "Razlog odbijanja",
    "noPreview": "Nema pregleda",
    "measurementLines": "Stavke",
    "colPosition": "Stavka",
    "colQuantity": "Količina",
    "colUnit": "Jedinica",
    "colNote": "Napomena",
    "acceptVisit": "Odobri posjet",
    "rejectVisit": "Odbij posjet",
    "acceptPhoto": "Prihvati fotografiju",
    "retakePhoto": "Zatraži ponovno snimanje",
    "approveMeasurement": "Odobri obračun",
    "returnMeasurement": "Vrati obračun",
    "acceptVisitHint": "Sati posjeta se preuzimaju.",
    "rejectVisitHint": "Sati ovog posjeta se blokiraju. Razlog vide kontrola i podizvođač.",
    "retakeHint": "Podizvođač dobiva zadatak da ponovno snimi fotografiju.",
    "returnHint": "Obračun se s vašim razlogom vraća podizvođaču.",
    "approveHint": "Obračun se odobrava i može se naplatiti.",
    "done": "Odlučeno: {{action}}.",
    "actions": "Radnje na točki kontrole",
    "noRight": "Nemate pravo odlučivanja.",
    "flags": "Razlozi kontrole"
  },
  "fieldwork": {
    "title": "Terenski rad",
    "visits": "Posjeti i sati",
    "visitsEmpty": "Još nema posjeta.",
    "pits": "Jame",
    "pitsEmpty": "Još nema jama.",
    "measurements": "Obračuni",
    "measurementsEmpty": "Još nema obračuna.",
    "pitState": {
      "offen": "Otvorena",
      "provisorisch": "Privremeno zatvorena",
      "fertig": "Završena"
    },
    "pitDetail": {
      "asphalt_fehlt": "Nedostaje asfalt",
      "pflaster_fehlt": "Nedostaju opločnici"
    },
    "measurementStatus": {
      "SUBMITTED": "Čeka odobrenje",
      "APPROVED": "Odobreno",
      "RETURNED": "Vraćeno"
    },
    "barrierTaken": "Ograda odnesena",
    "visitOpen": "Posjet otvoren od {{date}}",
    "visitClosed": "{{from}} do {{to}}",
    "loadError": "Terenski rad nije se mogao učitati."
  },
  "areas": {
    "title": "Područja",
    "description": "Nalozi po području s otvorenim nalozima, rokovima i otvorenim jamama, kao popis i na karti.",
    "listTitle": "Popis",
    "mapTitle": "Karta",
    "mapLabel": "Karta područja. Ista područja navedena su pokraj kao popis.",
    "showOrders": "Prikaži naloge: {{key}}",
    "bundle": "Dodijeli dnevni paket",
    "bundleFor": "Dodijeli dnevni paket: {{key}}",
    "bundleCount": "Klasificiranih naloga u području koji će se objediniti: {{count}}.",
    "bundleNone": "U području nema klasificiranih naloga za objedinjavanje.",
    "openOrders": "{{count}} otvoreno",
    "pits": "Otvorenih jama: {{count}}",
    "noArea": "(bez područja)",
    "noLocation": "Područja bez središta nisu na karti, ali jesu u popisu.",
    "loadError": "Područja se nisu mogla učitati."
  },
  "pits": {
    "layer": "Sloj",
    "layerOrders": "Nalozi",
    "layerPits": "Jame",
    "filterState": "Stanje jame",
    "filterDetail": "Nedostajući sloj",
    "listTitle": "Jame na karti ({{count}})",
    "mapLabel": "Karta jama. Iste jame navedene su ispod kao popis.",
    "empty": "Nema jama za ove filtre.",
    "loadError": "Jame se nisu mogle učitati.",
    "noLocation": "Jama bez lokacije ({{count}}) nema na karti, ali jesu u popisu.",
    "barrier": "Ograda",
    "barrierYes": "odnesena",
    "barrierNo": "postavljena"
  },
  "dispatch": {
    "title": "Tjedni plan",
    "description": "Zakažite naloge povlačenjem na kolonu i dan. Blokade vidite prije povlačenja.",
    "prevWeek": "Prethodni tjedan",
    "nextWeek": "Sljedeći tjedan",
    "thisWeek": "Ovaj tjedan",
    "weekOf": "Tjedan od {{date}}",
    "candidatesTitle": "Nije zakazano",
    "candidatesHint": "Povucite na dan i kolonu ili odaberite „Zakaži …” (i tipkovnicom).",
    "noCandidates": "Nema naloga za zakazivanje.",
    "gridLabel": "Tjedni plan po koloni i danu",
    "crewHeader": "Kolona",
    "noCrews": "Nema vlastitih kolona.",
    "empty": "slobodno",
    "schedule": "Zakaži …",
    "reschedule": "Preplaniraj …",
    "dragHint": "Povucite za zakazivanje",
    "locked": "Blokirano",
    "notSchedulable": "Zakazivanje trenutačno nije moguće",
    "blockedDays": "Blokirano {{days}}: {{reason}}",
    "slotBlocked": "Blokirano: {{reason}}",
    "dropHere": "Ispustite ovdje",
    "dialogTitle": "Zakazivanje naloga",
    "dialogHint": "{{number}} se zakazuje za odabranu kolonu i dan.",
    "crew": "Kolona",
    "day": "Dan",
    "time": "Početak",
    "blockedOption": "{{label}} (blokirano: {{reason}})",
    "pickCrew": "Odaberite",
    "done": "{{number}} zakazan: {{day}}, {{crew}}.",
    "loadError": "Tjedni plan se nije mogao učitati.",
    "ofCrew": "{{crew}}, {{day}}",
    "blockedNow": "Ovaj cilj je blokiran.",
    "at": "{{time}} h",
    "notAcceptedYet": "Najprije dodijelite odnosno prihvatite, zatim zakažite"
  },
  "problem": {
    "unavailable": "Usluga trenutačno nije dostupna. Pokušajte ponovno kasnije.",
    "stale": "Zapis je u međuvremenu promijenjen. Učitajte ponovno i pokušajte opet.",
    "PERMIT_MAILBOX_UNAVAILABLE": "Poštanski pretinac za zahtjeve trenutačno nije dostupan. Zahtjev ostaje odobren; pošaljite ga kasnije putem „Podnesi“.",
    "PERMIT_MAIL_FAILED": "E-pošta tijelu nije poslana. Zahtjev ostaje odobren; pokušajte ponovno poslati kasnije.",
    "PERMIT_APPLICATION_INCOMPLETE": "Nedostaju obvezni podaci ili privitci: {{missing}}.",
    "PERMIT_APPLICATION_EXISTS": "Za ovu vrstu dozvole već je u tijeku zahtjev. Koristite produljenje ili novi zahtjev.",
    "PERMIT_APPLICATION_NOT_DRAFT": "Samo se nacrti mogu uređivati ili odobriti.",
    "PERMIT_APPLICATION_NOT_APPROVED": "Podnose se samo odobreni zahtjevi.",
    "PERMIT_APPLICATION_NOT_SUBMITTED": "Zahtjev još nije podnesen.",
    "PERMIT_NOT_EXTENDABLE": "Ova se dozvola ne može produljiti. Podnesite novi zahtjev.",
    "PERMIT_NOT_GRANTED": "Produljiti se mogu samo izdane dozvole.",
    "PERMIT_PERIOD_TOO_LONG": "Tijelo izdaje najviše {{maxDays}} dana.",
    "PERMIT_AUTHORITY_WITHOUT_EMAIL": "Za ovo tijelo nije pohranjena adresa e-pošte.",
    "PERMIT_CATALOG_MISSING": "Nedostaje unos u katalogu za ovu općinu i vrstu dozvole.",
    "PERMIT_FILE_INVALID": "Odabrana datoteka ne pripada ovom nalogu ili nije provjerena.",
    "BILLING_CHECKLIST_INCOMPLETE": "Nisu ispunjene sve točke provjere: {{open}}. Za prolaz moraju biti sve ispunjene; inače vratite troškovnik.",
    "BILLING_REVIEW_MISSING": "Troškovnik još nije provjeren.",
    "BILLING_NOT_INVOICED": "Račun još nije evidentiran.",
    "COST_SHEET_LOCKED": "Troškovnik je zaključan i više se ne može mijenjati.",
    "COST_SHEET_NOT_DRAFT": "Mijenjati se mogu samo nacrti.",
    "COST_SHEET_WRONG_STATUS": "Ova radnja nije moguća u trenutačnom statusu.",
    "MEASUREMENT_NOT_APPROVED": "Obračun količina još nije odobren.",
    "PRICE_LIST_MISSING": "Ne postoji aktivni cjenik.",
    "ORDER_NOT_BILLABLE": "Ovaj nalog još se ne može obračunati.",
    "UPLOAD_TYPE": "Dopušteni su samo PDF, JPEG, PNG ili HEIC.",
    "UPLOAD_REJECTED": "Datoteka je odbijena pri provjeri.",
    "UPLOAD_PENDING": "Datoteka se još provjerava. Pričekajte trenutak i odaberite je ponovno.",
    "PERMIT_ATTACHMENT_INVALID": "Privitak ne pripada ovom nalogu ili nije provjeren.",
    "CREW_NAME_TAKEN": "Ekipa s tim nazivom već postoji.",
    "USER_EMAIL_TAKEN": "Ta je adresa e-pošte već zauzeta."
  },
  "blockerCode": {
    "ORDER_PERMIT_MISSING": "Ne postoji važeća dozvola.",
    "PERMIT_MISSING": "Ne postoji važeća dozvola.",
    "PERMIT_MISSING_AT_START": "Na dan početka ne postoji važeća dozvola.",
    "PERMIT_CATALOG_MISSING": "U katalogu tijela nedostaje unos za ovu općinu. Dodajte ga.",
    "ORDER_TYPE_UNKNOWN": "Vrsta naloga nije poznata. Klasificirajte nalog.",
    "CREW_SET_BY_GC": "Kolonu je odredio glavni izvođač i ne može se mijenjati.",
    "CREW_ONLY_OWN_ASSIGNMENT": "Kolona se može odabrati samo za vlastitu dodjelu.",
    "CREW_NOT_EXECUTOR": "Odabrana osoba ne smije izvršavati naloge i nije kolona."
  },
  "permits": {
    "title": "Dozvole",
    "create": "Izradi zahtjev",
    "statusValid": "Postoji važeća dozvola ili se ne traži nijedna.",
    "statusMissing": "Nedostaje važeća dozvola:",
    "reason": {
      "MISSING": "Za „{{type}}“ ne postoji dozvola.",
      "NOT_VALID_ON_DAY": "Dozvola „{{type}}“ ne vrijedi na dan radova.",
      "ORDER_TYPE_UNKNOWN": "Vrsta naloga nije poznata pa se obveza dozvole ne može procijeniti. Klasificirajte nalog.",
      "CATALOG_MISSING": "U katalogu tijela nedostaje unos za ovu općinu. Dodajte ga."
    },
    "validRange": "(vrijedi {{from}} – {{to}})",
    "loadError": "Dozvole se nisu mogle učitati.",
    "empty": "Još nema zahtjeva za ovaj nalog.",
    "history": {
      "created": "Nacrt izrađen",
      "approved": "Odobreno za podnošenje",
      "submitted": "Podneseno",
      "decided": "Rješenje evidentirano"
    },
    "historyTitle": "Povijest ({{count}})",
    "direction": {
      "OUT": "Odlazno",
      "IN": "Dolazno"
    },
    "messageKind": {
      "APPLICATION": "Zahtjev",
      "FOLLOW_UP": "Požurnica",
      "RECEIPT": "Potvrda primitka",
      "DECISION": "Rješenje",
      "OTHER": "Ostalo"
    },
    "messageStatus": {
      "SENT": "poslano",
      "FAILED": "neuspjelo",
      "MATCHED": "pridruženo",
      "UNMATCHED": "nepridruženo"
    },
    "status": {
      "DRAFT": "Nacrt",
      "APPROVED": "Odobreno",
      "SUBMITTED": "Podneseno",
      "GRANTED": "Izdano",
      "REJECTED": "Odbijeno",
      "WITHDRAWN": "Povučeno",
      "SUPERSEDED": "Zamijenjeno"
    },
    "kind": {
      "NEW": "Novi zahtjev",
      "EXTENSION": "Produljenje",
      "RENEWAL": "Obnova"
    },
    "replaceReason": "Razlog: {{reason}}",
    "period": "Traženo razdoblje",
    "field": {
      "location_address": "Mjesto radova",
      "cadastralParcel": "Katastarska čestica",
      "trench_lengthM": "Duljina rova (m)",
      "trench_widthM": "Širina rova (m)",
      "trench_depthM": "Dubina rova (m)",
      "trafficResponsible_name": "Odgovorna osoba",
      "trafficResponsible_phone": "Telefon odgovorne osobe",
      "trafficScheme": "Regulacija prometa",
      "remarks": "Napomene"
    },
    "attachment": {
      "ROUTE_SKETCH": "Skica ceste / situacijski plan",
      "TRAFFIC_SCHEME": "Plan prometne signalizacije",
      "ENGINEER_DECLARATION": "Izjava inženjera",
      "FEE_PROOF": "Dokaz o naknadi",
      "CADASTRAL_EXTRACT": "Katastarski izvadak",
      "OWNER_CONSENT": "Suglasnost vlasnika",
      "OTHER": "Ostalo"
    },
    "outcome": {
      "GRANTED": "Izdano",
      "REJECTED": "Odbijeno"
    },
    "fileNumber": "Klasa / broj spisa",
    "validity": "Valjanost",
    "conditions": "Uvjeti",
    "edit": "Uredi",
    "approve": "Odobri",
    "submit": "Podnesi",
    "followUp": "Požuri",
    "decision": "Evidentiraj rješenje",
    "extension": "Produlji",
    "renewal": "Novi zahtjev",
    "saved": "{{number}} spremljeno.",
    "approved": "{{number}} odobreno.",
    "submitted": "{{number}} podneseno.",
    "followedUp": "Požurnica za {{number}} poslana.",
    "decided": "Rješenje za {{number}} evidentirano.",
    "created": "{{number}} izrađeno.",
    "createHint": "Zahtjev se predispunjava iz podataka naloga. Bez razdoblja vrijedi predloženo.",
    "permitType": "Vrsta dozvole",
    "from": "Od",
    "to": "Do",
    "periodHint": "Tijelo može ograničiti trajanje.",
    "editHint": "Dopunite podatke koji nedostaju. Privitci mogu biti samo provjerene datoteke ovog naloga.",
    "noAttachment": "Nema datoteke",
    "attachmentHint": "Ako datoteka nedostaje, najprije je učitajte na nalogu pod Datoteke.",
    "approveHint": "Provjerava obvezne podatke i privitke. Kod podnošenja e-poštom zahtjev odmah ide tijelu; bez odobrenja se ništa ne šalje.",
    "submitHint": "Odobreni zahtjev šalje se ponovno odnosno bilježi kao podnesen.",
    "followUpHint": "Ovaj upit ide tijelu. Sljedeći rok za požurnicu pomiče se nakon toga.",
    "draftError": "Nacrt se nije mogao učitati.",
    "mailTo": "Prima",
    "mailSubject": "Predmet",
    "mailBody": "Tekst",
    "decisionHint": "Evidentira rješenje tijela. Kod izdavanja se valjanost prati kao rok.",
    "outcomeLabel": "Ishod",
    "decidedOn": "Rješenje od",
    "validFrom": "Vrijedi od",
    "validTo": "Vrijedi do",
    "decisionFile": "Rješenje (PDF ili slika)",
    "renewalHint": "Zahtjev u tijeku se zamjenjuje. Razlog je obvezan i bilježi se.",
    "mailbox": {
      "record": "Evidentiraj dolaznu poruku",
      "unmatchedTitle": "Nepridružene dolazne poruke",
      "emptyTitle": "Sve je pridruženo",
      "emptyBody": "Nema poruka bez zahtjeva. Pridruživanje ide prema broju zahtjeva [ANT-GGGG-NNNNN] u predmetu.",
      "recordHint": "Ručno evidentira dolaznu poruku. Ako predmet sadrži broj zahtjeva [ANT-GGGG-NNNNN], pridružuje se tom zahtjevu.",
      "kind": "Vrsta",
      "matched": "Poruka evidentirana i pridružena zahtjevu.",
      "unmatched": "Poruka evidentirana, ali nije pridružena zahtjevu."
    },
    "saveDraft": "Spremi nacrt",
    "catalogEmpty": "Za ovu općinu u katalogu nema vrste zahtjeva.",
    "catalogMandatory": "Obvezni prilozi",
    "catalogDays": "Uobičajeno trajanje obrade: {{days}} radnih dana"
  },
  "billing": {
    "title": "Obračun",
    "clientAmount": "Iznos naručitelja",
    "subAmount": "Iznos podizvođača",
    "margin": "Marža",
    "subTitle": "Obračun podizvođača",
    "loadError": "Obračun se nije mogao učitati.",
    "subNone": "Još nema obračuna podizvođača.",
    "subStatus": {
      "DRAFT": "Nacrt",
      "APPROVED": "Odobreno"
    },
    "total": "Ukupno",
    "col": {
      "no": "Br.",
      "kind": "Vrsta",
      "position": "Pozicija",
      "text": "Tekst",
      "quantity": "Količina",
      "unit": "Jedinica",
      "unitPrice": "Jedinična cijena",
      "amount": "Iznos",
      "actions": "Radnje"
    },
    "deviation": {
      "NOT_IN_CATALOG": "Nije u troškovniku",
      "NO_PRICE": "Bez cijene"
    },
    "kind": {
      "SERVICE": "Usluga",
      "WORK": "Rad",
      "MATERIAL": "Materijal"
    },
    "status": {
      "DRAFT": "Nacrt",
      "REVIEWED": "Provjereno",
      "RETURNED": "Vraćeno",
      "SUBMITTED": "Preneseno u IDBM",
      "CLIENT_APPROVED": "Potvrdio HT",
      "CLIENT_REJECTED": "Odbio HT",
      "BILLED": "Obračunano"
    },
    "regenerate": "Ponovno izradi",
    "generate": "Izradi troškovnik",
    "addLine": "Dodaj redak",
    "pass": "Prođi provjeru",
    "returnSheet": "Vrati",
    "submit": "Prenesi u IDBM",
    "decision": "Evidentiraj odluku HT-a",
    "invoice": "Evidentiraj račun",
    "none": "Još nema troškovnika. Nastaje iz odobrenog obračuna količina.",
    "lineDeleted": "Redak obrisan.",
    "showTransfer": "Prikaži prikaz za prijenos",
    "hideTransfer": "Sakrij prikaz za prijenos",
    "generateHint": "Količine po poziciji zbrajaju se iz odobrenog obračuna količina, cijene dolaze iz aktivnog cjenika. Dodani retci ostaju.",
    "generated": "Troškovnik izrađen.",
    "lineAdded": "Redak dodan.",
    "passed": "Provjera prošla: troškovnik provjeren.",
    "returned": "Troškovnik vraćen.",
    "submitted": "Preneseno u IDBM.",
    "decided": "Odluka HT-a evidentirana.",
    "invoiced": "Račun evidentiran: obračunano.",
    "idbmNumber": "Broj u IDBM-u",
    "submitHint": "Unesite broj pod kojim je troškovnik izrađen u IDBM-u.",
    "invoiceNumber": "Broj računa",
    "invoiceHint": "Nakon toga na nalogu je moguće „Označi kao obračunano“.",
    "revision": "Revizija {{revision}}",
    "flow": "Tijek obračuna",
    "returnedBecause": "Vraćeno: {{reason}}",
    "rejectedBecause": "Odbio HT: {{reason}}",
    "idbmDifference": "Razlika u IDBM-u {{amount}} (potvrđeno: {{approved}})",
    "idbmNumberValue": "Broj u IDBM-u: {{number}}",
    "invoiceNumberValue": "Račun: {{number}}",
    "linesLabel": "Retci troškovnika",
    "deleteLine": "Obriši redak {{no}}",
    "delete": "Obriši",
    "transferError": "Prikaz za prijenos dostupan je tek nakon prolaska provjere.",
    "transferHint": "Polja redoslijedom IDBM obrasca, bez cijena. Svako polje može se zasebno kopirati.",
    "transferLabel": "Prikaz za prijenos u IDBM",
    "copyField": "Kopiraj polje: {{field}}",
    "copied": "Kopirano: {{field}}.",
    "downloadXlsx": "Preuzmi XLSX",
    "downloadError": "Preuzimanje nije uspjelo.",
    "lineHint": "Dodajte redak rada ili materijala. Materijal treba EDM broj.",
    "edmNo": "EDM broj",
    "warehouse": "Skladište",
    "batch": "Serija",
    "serialNo": "Serijski broj",
    "checklist": "Točke provjere",
    "passHint": "Za prolaz moraju biti ispunjene sve točke. Nakon toga moguć je prijenos u IDBM.",
    "returnHint": "Troškovnik se vraća podizvođaču s vašim obrazloženjem.",
    "check": {
      "measurement_matches_photos": "Obračun količina odgovara fotografijama",
      "documents_complete": "Dokumenti potpuni",
      "positions_match_catalog": "Pozicije odgovaraju troškovniku",
      "materials_recorded": "Materijal evidentiran"
    },
    "decisionHint": "Odluka HT-a iz IDBM-a. Troškovnik: {{total}}. Odbijanje se vraća podizvođaču s razlogom.",
    "outcome": "Odluka",
    "outcomeApproved": "Potvrđeno",
    "outcomeRejected": "Odbijeno",
    "approvedAmount": "Potvrđeni iznos",
    "rejectReason": "Razlog odbijanja"
  },
  "classification": {
    "suggestion": "Prijedlog AI klasifikacije: {{type}} ({{percent}} % sigurnosti)",
    "hint": "Ispod praga vrstu naloga potvrđuje dispozicija.",
    "confirm": "Potvrdi prijedlog",
    "other": "Odaberi drugu vrstu naloga",
    "confirmHint": "Nalog će biti klasificiran kao „{{type}}“.",
    "otherHint": "Odaberite vrstu naloga kojom će se nalog klasificirati.",
    "done": "Nalog klasificiran kao „{{type}}“.",
    "type": {
      "INSTALLATION": "Instalacija",
      "FAULT": "Kvar",
      "RELOCATION": "Preseljenje",
      "DISCONNECTION": "Isključenje",
      "CIVIL_WORKS": "Građevinski radovi"
    }
  },
  "combobox": {
    "placeholder": "Odaberite ili pretražite …",
    "empty": "Nema rezultata",
    "unavailable": "Popis nije dostupan.",
    "clear": "Ukloni odabir",
    "noneChosen": "Nema odabira",
    "remove": "Ukloni: {{name}}"
  },
  "crewAdmin": {
    "create": "Dodaj ekipu",
    "showInactive": "Prikaži neaktivne ekipe",
    "loadError": "Ekipe se nisu mogle učitati.",
    "loadErrorBody": "Pokušajte ponovno kasnije.",
    "active": "Aktivna",
    "inactive": "Neaktivna",
    "edit": "Uredi",
    "activate": "Aktiviraj",
    "deactivate": "Deaktiviraj",
    "leader": "Voditelj ekipe",
    "members": "Članovi ({{count}})",
    "activateHint": "Ekipa „{{name}}“ ponovno se aktivira i može se birati pri dispoziciji.",
    "deactivateHint": "Ekipa „{{name}}“ se deaktivira i više se ne može birati pri dispoziciji. Postojeći termini ostaju.",
    "activated": "Ekipa „{{name}}“ je aktivirana.",
    "deactivated": "Ekipa „{{name}}“ je deaktivirana.",
    "save": "Spremi ekipu",
    "createHint": "Odredite naziv te odaberite voditelja i članove među korisnicima svoje organizacije.",
    "editHint": "Promijenite naziv, voditelja, članove i status.",
    "name": "Naziv",
    "nameTaken": "Ekipa s tim nazivom već postoji.",
    "membersLabel": "Članovi",
    "activeLabel": "Ekipa je aktivna",
    "saved": "Ekipa „{{name}}“ je spremljena.",
    "created": "Ekipa „{{name}}“ je dodana.",
    "org": "Organizacija",
    "ownOrg": "Vlastita organizacija"
  },
  "admin": {
    "tab": {
      "users": "Korisnici",
      "organizations": "Organizacije",
      "sites": "Lokacije"
    },
    "search": "Pretraga (ime ili e-pošta)",
    "createUser": "Dodaj korisnika",
    "createUserHint": "Korisnik dobiva jednokratnu početnu lozinku ili pozivnu poveznicu. Oboje se prikazuje samo jednom.",
    "col": {
      "name": "Ime",
      "email": "E-pošta",
      "org": "Organizacija",
      "role": "Uloga",
      "sites": "Lokacije",
      "status": "Status",
      "actions": "Radnje"
    },
    "editRole": "Promijeni ulogu",
    "editRoleHint": "Promijenite ulogu, lokacije i status korisnika {{name}}.",
    "newOnboarding": "Nova početna lozinka",
    "onboardingHint": "Za korisnika {{name}} stvara se nova jednokratna početna lozinka odnosno pozivna poveznica. Dosadašnji pristup prestaje vrijediti.",
    "userCreated": "Korisnik {{name}} je dodan.",
    "userSaved": "Korisnik {{name}} je spremljen.",
    "loadError": "Podaci se nisu mogli učitati.",
    "loadErrorBody": "Pokušajte ponovno kasnije.",
    "secretTitle": "Pristup za {{name}}",
    "secretOnce": "Ovaj se pristup prikazuje samo sada. Poslije ga nitko ne može ponovno dohvatiti, ni administracija.",
    "tempPassword": "Početna lozinka",
    "inviteLink": "Pozivna poveznica",
    "copy": "Kopiraj",
    "copied": "Kopirano",
    "secretNone": "Poslužitelj nije vratio pristup.",
    "validUntil": "Vrijedi do {{date}}",
    "secretWarning": "Pristup predajte samo osobno ili sigurnim kanalom.",
    "secretClose": "Zapisano, zatvori",
    "createOrg": "Dodaj organizaciju",
    "createOrgHint": "Odredite naziv i vrstu. Lokacije i korisnike dodajete poslije.",
    "orgCreated": "Organizacija {{name}} je dodana.",
    "orgKindLabel": "Vrsta",
    "orgKind": {
      "GC": "Glavni izvođač (GU)",
      "SUB": "Podizvođač",
      "CLIENT": "Naručitelj"
    },
    "createSite": "Dodaj lokaciju",
    "createSiteHint": "Lokacija pripada organizaciji i ograničava koje naloge korisnik vidi.",
    "siteCreated": "Lokacija {{name}} je dodana.",
    "siteName": "Naziv lokacije",
    "sitesEmptyTitle": "Još nema lokacija",
    "sitesEmptyBody": "Dodajte lokacije kako biste ograničili pristup korisnika.",
    "pickOrgFirst": "Najprije odaberite organizaciju.",
    "activeLabel": "Korisnik je aktivan",
    "locale": "Jezik",
    "sendInvite": "Pošalji pozivnicu e-poštom umjesto početne lozinke",
    "userInvited": "Korisnik {{name}} je dodan, pozivnica je poslana.",
    "saveRoles": "Spremi uloge",
    "revoke": "Oduzmi",
    "revokeRole": "Oduzmi ulogu: {{name}}",
    "newRole": "novo",
    "addRole": "Dodaj ulogu",
    "scopeSite": "Ograničeno na lokaciju (neobavezno)",
    "allSites": "Sve lokacije",
    "addRoleButton": "Označi ulogu",
    "profile": "Profil naručitelja",
    "siteCode": "Oznaka lokacije",
    "siteAddress": "Adresa (neobavezno)"
  },
  "history": {
    "title": "Povijest",
    "immutable": "Svaka verzija i svaki događaj pohranjuju se nepromjenjivo i povezano (otporno na izmjene). Unosi se ne mogu ni mijenjati ni brisati.",
    "noPrices": "Cijene i marže nisu uključene u vašu povijest.",
    "version": "Verzija {{version}}",
    "event": "Događaj",
    "system": "Sustav",
    "hash": "Kontrolni zbroj",
    "hashHint": "Kontrolni zbroj lanca; mijenja se pri svakoj naknadnoj manipulaciji.",
    "changesOf": "Promjene: {{summary}}",
    "col": {
      "field": "Polje",
      "from": "Prije",
      "to": "Poslije"
    },
    "more": "Učitaj starije unose",
    "loadError": "Povijest se nije mogla učitati.",
    "loadErrorBody": "Pokušajte ponovno kasnije.",
    "emptyTitle": "Još nema povijesti",
    "emptyBody": "Verzije i događaji ovog naloga pojavit će se ovdje.",
    "field": {
      "address": "Adresa",
      "status": "Status",
      "orderType": "Vrsta naloga",
      "scheduledStart": "Termin",
      "crew": "Ekipa",
      "price": "Cijena",
      "assigneeOrgId": "Podizvođač",
      "clientStatus": "Status naručitelja",
      "externalRef": "Vanjska oznaka",
      "rajon": "Rajon",
      "municipality": "Općina"
    },
    "action": {
      "CREATED": "Kreirano",
      "REVISED": "Izmijenjeno",
      "SUBMITTED": "Predano",
      "STATUS_CHANGED": "Status promijenjen",
      "SCHEDULE": "Termin promijenjen",
      "CREW_CHANGED": "Ekipa promijenjena",
      "REQUEST_SCHEDULE": "Željeni termin",
      "DELETED": "Obrisano"
    }
  },
  "permitFiles": {
    "title": "Prilozi",
    "required": "Obvezno",
    "requiredMissing": "Ovaj obvezni prilog još nedostaje.",
    "state": {
      "missing": "Nije učitano",
      "UPLOADED": "Učitano",
      "VERIFIED": "Provjereno",
      "REJECTED": "Odbijeno"
    },
    "upload": "Učitaj: {{kind}}",
    "replace": "Zamijeni: {{kind}}",
    "uploading": "Učitavanje …",
    "saved": "Prilog „{{kind}}“ je spremljen.",
    "rejectedBody": "Datoteka je odbijena. Razlog: {{reason}}",
    "rejectedUnknown": "nepoznat",
    "hintDraft": "Prilozi se mogu učitati i zamijeniti u nacrtu. Dopušteni su PDF, JPEG, PNG i HEIC.",
    "hintLocked": "Nakon odobrenja prilozi su zaključani.",
    "template": "Službeni obrasci općine",
    "templateDownload": "Preuzmi {{name}}",
    "templateError": "Obrazac se nije mogao učitati.",
    "templateSource": "Izvor",
    "templateRetrieved": "preuzeto {{date}}",
    "loadError": "Prilozi se nisu mogli učitati.",
    "note": "Napomena",
    "noteLabel": "Napomena uz {{kind}} (neobavezno)",
    "noteLabelOther": "Napomena uz sljedeći ostali prilog (neobavezno)",
    "noteSave": "Spremi napomenu",
    "noteSaved": "Napomena uz „{{kind}}” spremljena.",
    "remove": "Ukloni {{kind}}",
    "removed": "Prilog „{{kind}}” uklonjen.",
    "add": "Dodaj {{kind}}",
    "otherItem": "Datoteka {{n}}",
    "otherCount": "Datoteke: {{count}}"
  },
  "pitPhotos": {
    "show": "Prikaži fotografije",
    "pick": "Odaberite jamu da vidite fotografije triju faza.",
    "title": "Fotografije jame {{label}}",
    "missing": "Nedostaju fotografije za: {{phases}}.",
    "phase": {
      "VOR_OEFFNEN": "Prije otvaranja",
      "WAEHREND_ARBEITEN": "Tijekom radova",
      "NACH_SCHLIESSEN": "Nakon zatvaranja"
    },
    "none": "Nema fotografija u ovoj fazi.",
    "notDueYet": "Još nije na redu: jama je još otvorena.",
    "photoError": "Fotografija se nije mogla učitati.",
    "loadError": "Jama se nije mogla učitati."
  },
  "search": {
    "label": "Pretraži naloge",
    "placeholder": "Traži nalog (broj, adresa) …",
    "hint": "Unesite najmanje dva znaka",
    "none": "Nalog nije pronađen",
    "error": "Pretraga trenutačno nije dostupna"
  },
  "requested": {
    "set": "Postavi željeni termin",
    "clear": "Obriši željeni termin",
    "hint": "Željeni termin nije obvezujući i ne mijenja status. Obvezujući termin određuje dispozicija.",
    "clearHint": "Željeni termin se uklanja.",
    "note": "Napomena (neobavezno)",
    "past": "Željeni termin mora biti u budućnosti.",
    "saved": "Željeni termin je spremljen.",
    "cleared": "Željeni termin je obrisan.",
    "label": "Željeni termin",
    "noteLabel": "Napomena uz željeni termin",
    "crew": "Ekipa"
  }
}
